import { useAction } from "@/hooks/shared";
import { forgotPasswordHandler } from "@/services";

export const useForgotPassword = () => useAction(forgotPasswordHandler);
